import React from 'react'
import { connect } from 'react-redux'
import { styled, useTheme } from '@mui/material/styles'
import { Box, Paper } from '@mui/material'
import { classNamesK } from '../../lib/util'
import { initialScore } from '../../redux/reducers/score'
import { initialBoard } from '../../redux/reducers/board'
import { initialButtonUser } from '../../redux/reducers/button'
import Above from './Above'
import Plate from './Plate'
import Score from './score/Score'
import EditScore from './EditScore'
import Below from './Below'
import Board from './Board'
import './Player.scss'

const PlayerPaper = styled(Paper)(
  ({ theme }) => `
  &.my-turn {
    background-color: ${theme.palette.player.myTurn1};
  }
`
)

const Player = ({ player, score: { sg, edit }, board: { bg }, button, rule }) => {
  const theme = useTheme()

  const { order, delay, myTurn } = button.user.get(player) || initialButtonUser
  const score = sg.player.scores.get(player) || initialScore
  const board = bg.boards.get(player) || initialBoard

  const mainComponent = () => {
    if (edit) {
      return <EditScore className="edit-score" player={player} />
    } else {
      return (
        <>
          <Box className="grid-score">
            <Score score={score} />
          </Box>
          {rule.board.active && <Board className="board" board={board} />}
        </>
      )
    }
  }

  return (
    <Box className="player">
      {!edit && <Above player={player} order={order} delay={delay} score={score} />}
      <PlayerPaper elevation={theme.palette.player.elevation}
                   className={classNamesK('player-box', { myTurn })}>
        <Box className="grid-name">
          <Plate player={player} myTurn={myTurn} />
        </Box>
        {mainComponent()}
      </PlayerPaper>
      {!edit && <Below score={score} />}
    </Box>
  )
}

export default connect(
  state => ({
    board: state.board,
    score: state.score,
    button: state.button,
    rule: state.rule
  })
)(Player)
